<template>
  <div
    class="ti-navigation"
    :class="{ 'ti-navigation--no-prev': history.length == 0 }"
  >
    <!-- <button
      v-if="history && history.length > 0"
      type="button"
      class="ti-navigation__cta-tertiary wb-button wb-button--tertiary wb-button--medium"
      @click="prev"
    >
      <wb-icon class="wb-button__icon" aria-hidden="true" flip-rtl name="chevron-left"></wb-icon>
      <span>{{ $t('i18n.navigation.prevButton.default') }}</span>
    </button> -->

    <button
      v-if="step && step.next"
      type="button"
      class="ti-navigation__cta-primary wb-button wb-button--primary wb-button--medium"
      :disabled="!step.completed && !completed"
      @click="next"
    >
      <wb-icon
        class="wb-button__icon"
        aria-hidden="true"
        flip-rtl
        name="chevron-right"
      ></wb-icon>
      <span>{{ nextLabel }}</span>
    </button>
  </div>
</template>
<script lang="ts" setup>
import { Step } from '@tradein/api';
import { StepIds } from '@tradein/store';
import { onMounted, onUnmounted, Ref, ref, watch } from 'vue';
import { trackingService } from '../../utils/tracking';
import i18nManager from '../../composables/i18nManager';

interface Props {
  step: Step;
  history: Step[];
  completed?: boolean;
}

const { i18n } = i18nManager();
const props = defineProps<Props>();
const emit = defineEmits(['nextClicked', 'prevClicked']);

const nextLabel = ref('');
const nextLabels: Ref<any> = ref({} as any);

watch(props.step, () => {
  getNextLabel();
});

onMounted(() => {
  nextLabels.value = i18n.value.t('i18n.navigation.nextButton') as any;
  getNextLabel();

  window.addEventListener('keydown', enterListener);
});

onUnmounted(() => {
  window.removeEventListener('keydown', enterListener);
});

const enterListener = (e: KeyboardEvent) => {
  if (
    e.key === 'Enter' &&
    props.step.next &&
    (props.step.completed || props.completed)
  ) {
    next();
  }
};

const getNextLabel = (): void => {
  const next = noResidualValueDealerSelection() || props.step?.next;

  nextLabel.value = props.step?.data?.oneJourney
    ? (i18n.value.t('i18n.navigation.nextButton.default') as string)
    : (nextLabels as any).value[next]
      ? (nextLabels as any).value[next]
      : (i18n.value.t('i18n.navigation.nextButton.default') as string);
};

const noResidualValueDealerSelection = () => {
  return !props.step?.data?.residualValue &&
    props.step?.next === 'DEALERSELECTION'
    ? 'NORESIDUALVALUEDEALERSELECTION'
    : '';
};

const next = (): void => {
  emit('nextClicked');
};

const prev = (): void => {
  emit('prevClicked');

  trackingService.publishClick(`feature`, `${props.step?.stepId}.back`);
};
</script>
<style lang="scss">
.ti-navigation {
  @include wb-spacing('padding', 's 0');

  width: 100%;
  display: flex;

  @include breakpoint-between(mq0, mq3) {
    flex-direction: column-reverse;
  }

  @include breakpoint-from(mq3) {
    flex-direction: row;
    justify-content: flex-end;

    &--no-prev {
      justify-content: flex-end;
    }
  }

  &__cta-primary {
    @include breakpoint-between(mq0, mq3) {
      width: 100%;
    }

    &.wb-button--medium {
      min-width: 122px;
    }
  }

  &__cta-tertiary {
    @include breakpoint-between(mq0, mq3) {
      @include wb-spacing('margin-top', 'xxs');

      width: 100%;
    }
  }
}
</style>
